import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { selectCartSize } from "../../../../../redux/cart";
import { APP_PATHS } from "../../../../../constants/paths";
import shoppingCart from "../../../../../assets/icons/shopping_cart.svg";
import classes from "./ShoppingCart.module.css";

const ShoppingCart = () => {
  const cartItemsCount = useSelector(selectCartSize);

  return (
    <Link
      to={APP_PATHS.CART.url}
      className={classNames("flex items-center", classes["shopping-cart"])}
    >
      <img
        src={shoppingCart}
        alt="shopping cart"
        className={classes["shopping-cart__icon"]}
      />
      <span className={classes["shopping-cart__text"]}>عربة التسوق</span>
      <div
        className={classNames(
          "numeric-content flex justify-center items-center",
          classes["shopping-cart__count"]
        )}
      >
        {cartItemsCount > 99 ? "+99" : cartItemsCount}
      </div>
    </Link>
  );
};

export default ShoppingCart;
